import { deleteLabelValue, localizeLabelCategory, localizeLabelValueName } from '@tableau/catalog-ui-temp';
import { restApiService } from '@tableau/vizportalclient-common-components';
import { call, put } from 'redux-saga/effects';

import { requestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { RevertToDefaultLabelAction } from '~src/catalog/actions/labels/RevertToDefaultLabelAction';
import { DialogBodyProps, getActionDialogOptions } from '~src/catalog/components/labels/RevertToDefaultLabelDialog';
import { openReactActionDialog } from '~src/commonInfra/dialogs/ReactActionDialog';
import { ToasterService, ToastType } from '~src/commonInfra/services/ToasterService';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { reloadSpaceIfUpdatingCurrentSpace } from '~src/spacesPlatform/sagas/content/RefreshContentSagas';

import { Messages } from '../../../codegen/Localize';

export function* handleRevertToDefaultLabelValue(action: RevertToDefaultLabelAction) {
    try {
        yield call(openRevertToDefaultLabel, action);

        const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, [action.item]);
        if (!maybeReloaded) {
          yield put(requestSpaceContents());
        }
    } catch(e) {
        yield put(requestFailed(e, Messages.errorUnknown()));
    }
}


export function openRevertToDefaultLabel(action: RevertToDefaultLabelAction): PromiseLike<unknown> {
    const doAction: (dialogBodyProps: DialogBodyProps) => Promise<unknown> = () => {
        const siteLuid = SessionSiteSelectors.siteLuid(getAppStore().getState());
        const {makeJsonRestApiRequest} = restApiService({siteLuid});

        return deleteLabelValue({makeJsonRestApiRequest, labelValue: {name: action.item.value, category: action.item.category, description: action.item.labelDescription}},
          action.item.value).then(async (_: unknown) => {
            ToasterService.instance.pop({
              type: ToastType.Info,
              text: Messages.revertToDefaultLabel_toast({
                LABEL_CATEGORY: localizeLabelCategory(action.item.category),
                LABEL_VALUE: localizeLabelValueName(action.item.value)}),
            });
          }).catch((_: unknown) => ToasterService.instance.pop({
            type: ToastType.Error,
            text: Messages.error(),
          }));
    };

    const modalInstance = openReactActionDialog(getActionDialogOptions({
      doAction,
      initialBodyProps: {labelCategory: action.item.category, labelDescription: action.item.labelDescription, labelValue: action.item.value, visibility: action.item.visiblity}
    }));

    return modalInstance.result;
}
